module.exports = __webpack_public_path__ + "img/bilibili-winter-view-1.f67d9ca8.f67d9ca8.jpg";